module.exports = __webpack_public_path__ + "2c0ff8d75e3bd695c39348e699f9fec9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-29.png
// module id = 2294
// module chunks = 0